<!--
 * @Author:
 * @LastEditTime: 2023-07-28
 * @Description: 风险分析单元
-->
<template>
  <el-card class="h-full">
    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="按区域统计" name="area">
        <div v-if="activeName === 'area'">
          <area-statistics :values="areaValues"></area-statistics>
          <el-table
            ref="areaDataList"
            :data="areaDataList"
            border
            class="w-full"
            height="calc(100vh - 634px)"
            stripe
            v-loading="areaTableLoading"
            show-summary
            @sort-change="(sortColumn) => sortChangeTable(sortColumn, 'areaDataList')"
          >
            <el-table-column
              label="区域名称"
              prop="areaText"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="重大风险数量"
              prop="significantRiskCount"
              show-overflow-tooltip
              sortable
            ></el-table-column>
            <el-table-column
              label="较大风险数量"
              prop="greaterRiskCount"
              show-overflow-tooltip
              sortable
            ></el-table-column>
            <el-table-column
              label="一般风险数量"
              prop="generalRiskCount"
              show-overflow-tooltip
              sortable
            ></el-table-column>
            <el-table-column
              label="低风险数量"
              prop="lowRiskCount"
              show-overflow-tooltip
              sortable
            ></el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="按管控责任部门统计" name="department">
        <div v-if="activeName === 'department'">
          <department-statistics :values="departmentValues"></department-statistics>
          <el-table
            ref="departmentDataList"
            :data="departmentDataList"
            border
            class="w-full"
            height="calc(100vh - 634px)"
            stripe
            v-loading="departmentTableLoading"
            show-summary
            @sort-change="(sortColumn) => sortChangeTable(sortColumn, 'departmentDataList')"
          >
            <el-table-column
              label="部门"
              prop="organizationUnitText"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="重大风险数量"
              prop="significantRiskCount"
              show-overflow-tooltip
              sortable
            ></el-table-column>
            <el-table-column
              label="较大风险数量"
              prop="greaterRiskCount"
              show-overflow-tooltip
              sortable
            ></el-table-column>
            <el-table-column
              label="一般风险数量"
              prop="generalRiskCount"
              show-overflow-tooltip
              sortable
            ></el-table-column>
            <el-table-column
              label="低风险数量"
              prop="lowRiskCount"
              show-overflow-tooltip
              sortable
            ></el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="风险变化趋势" name="trend">
        <div v-if="activeName === 'trend'">
          <trend-statistics :values="trendValues"></trend-statistics>
          <el-table
            :data="trendDataList"
            border
            class="w-full"
            height="calc(100vh - 634px)"
            stripe
            v-loading="trendTableLoading"
            show-summary
          >
            <el-table-column label="时间" prop="yearMonth" show-overflow-tooltip></el-table-column>
            <el-table-column
              label="重大风险数量"
              prop="significantRiskCount"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="较大风险数量"
              prop="greaterRiskCount"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="一般风险数量"
              prop="generalRiskCount"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="低风险数量"
              prop="lowRiskCount"
              show-overflow-tooltip
            ></el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import { RiskStatisticsApi } from '@wiz-api/double-prevention-management'
import AreaStatistics from '../components/AreaStatistics'
import DepartmentStatistics from '../components/DepartmentStatistics'
import TrendStatistics from '../components/TrendStatistics'

const riskStatisticsApi = new RiskStatisticsApi()

export default {
  name: 'risk-level-manage',
  components: {
    AreaStatistics,
    DepartmentStatistics,
    TrendStatistics,
  },
  data() {
    return {
      activeName: 'area',
      // 区域
      areaDataList: [],
      areaTableLoading: false,
      areaValues: {},
      // 部门
      departmentDataList: [],
      departmentTableLoading: false,
      departmentValues: {},
      // 趋势变化
      trendDataList: [],
      trendTableLoading: false,
      trendValues: {},
    }
  },
  created() {
    this.getAreaList()
    this.getDepartmentList()
    this.getTrendList()
  },
  methods: {
    sortChangeTable(sortColumn, table) {
      if (table === 'areaDataList') {
        this.areaValues = this.mapArr(this.$refs[table].tableData)
      }
      if (table === 'departmentDataList') {
        this.departmentValues = this.mapArr(this.$refs[table].tableData)
      }
    },
    handleTabClick(tab) {
      switch (tab.name) {
        case 'area':
          this.getAreaList()
          break
        case 'department':
          this.getDepartmentList()
          break
        case 'trend':
          this.getTrendList()
          break
        default:
          this.$message.warning('tab缺少name属性')
          break
      }
    },
    // 获取区域数据
    async getAreaList() {
      this.areaTableLoading = true
      const [err, res] = await riskStatisticsApi.riskStatisticsArea()
      if (!err) {
        this.areaDataList = res
        this.areaValues = this.mapArr(res)
      }
      this.areaTableLoading = false
    },
    // 获取部门数据
    async getDepartmentList() {
      this.departmentTableLoading = true
      const [err, res] = await riskStatisticsApi.riskStatisticsControlResponsibleDepartment()
      if (!err) {
        this.departmentDataList = res
        this.departmentValues = this.mapArr(res)
      }
      this.departmentTableLoading = false
    },
    // 获取趋势数据
    async getTrendList() {
      this.trendTableLoading = true
      const [err, res] = await riskStatisticsApi.riskStatisticsYearMonth()
      if (!err) {
        const data = res.reverse()
        this.trendDataList = data
        this.trendValues = this.mapArr(data)
      }
      this.trendTableLoading = false
    },
    // 数组分类别
    mapArr(
      arr,
      filedList = ['generalRiskCount', 'greaterRiskCount', 'significantRiskCount', 'lowRiskCount']
    ) {
      const result = arr.reduce((pre, item) => {
        // eslint-disable-next-line guard-for-in, no-restricted-syntax
        for (const key in item) {
          if (!pre[key]) {
            pre[key] = []
          }
          const flag = filedList.reduce((p, i) => {
            if (item[i]) {
              p = true
            }
            return p
          }, false)
          if (flag) {
            pre[key].push(item[key])
          }
        }
        return pre
      }, {})
      return result
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
